import { nodeUrl} from './Constants';

const wavesTransaction  = require('@waves/waves-transactions')


export async function createAccount(){
    /* For mainnet account creation
    const seed = wavesTransaction.seedUtils.Seed.create();
    */
    /* For Testnet Account Creation */
    const phrase=wavesTransaction.seedUtils.generateNewSeed();
    const seed = new wavesTransaction.seedUtils.Seed(phrase,84);
    // console.log(seed.phrase);
    // console.log(seed.address);
    // console.log(seed.keyPair);
    console.log('Account Created');
    return({
      'walletAddress':seed.address,
      'phrase':seed.phrase,
      'privateKey':seed.keyPair.privateKey,
      'publicKey':seed.keyPair.publicKey
    });
}